import React from 'react';
import classnames from 'classnames';
import { Modal, ModalProps } from 'tea-component';

import type { IBaseProps } from '@home/types/common';

export interface ISimpleModalProps extends IBaseProps, Omit<ModalProps, 'children'> {
  title: string | React.ReactElement | null;
  description: string | React.ReactElement | null;
  footer?: React.ReactElement | null;
}

const SimpleModal: React.FC<ISimpleModalProps> = (props) => {
  const { style, className, title, description, footer, ...restProps } = props;

  return (
    <Modal {...restProps} style={style} className={classnames('dbg-simple-modal', className)}>
      <Modal.Body>
        <div className="tea-media">
          <div className="tea-media__body">
            <h3 className="tea-dialog__messagetitle">{title}</h3>
            <div className="tea-dialog__messagetext">{description}</div>
          </div>
        </div>
      </Modal.Body>
      {React.isValidElement(footer) && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default React.memo(SimpleModal);
